import { IResultData } from "@/domain/entities/shared/result";
import {
  IHttpError,
  isHttpError,
} from "@/repositories/shared/errors/httpError";
import { ParseError } from "@/repositories/shared/errors/parseError";
import dayjs from "dayjs";

export default function useSetResultCodeIfNeeded<TModel>(
  resultData: IResultData<TModel>,
  error: IHttpError | ParseError
): void {
  if (isHttpError(error)) {
    resultData.resultCode = error.status;
    resultData.errorTime = dayjs(error.time).format("YYYY-MM-DD HH:mm:ss");
    resultData.errorData = error.data;
  }
}
